import { HttpParams } from '@angular/common/http';

export interface ListRequestDTO {
    pageIndex: number;
    pageSize: number;
    sortProperty: string | null;
    sortDirection: ListSortDirection;
    searchString?: string;
}

export function HttpParamsFromListRequestDTO(options: ListRequestDTO): HttpParams {
    let params = new HttpParams();
    params = params.append('pageSize', Number(options.pageSize));
    params = params.append('pageIndex', Number(options.pageIndex));
    if (options.sortProperty) {
        params = params.append('sortProperty', String(options.sortProperty));
        params = params.append('sortDirection', Number(options.sortDirection));
    }
    if (options.searchString) {
        params = params.append('searchString', String(options.searchString));
    }
    return params;
}

export enum ListSortDirection {
    Ascending = 0,
    Descending = 1,
}
